import { LOAD_CUSTOMERSERVICEINFO_SUCCESS, LOADING_CUSTOMERSERVICEINFO, LOAD_CUSTOMERSERVICEINFO_FAILURE } from './actionTypes';

export function loadCustomerServiceInfoSuccess(customerServiceInfo) {
    return { type: LOAD_CUSTOMERSERVICEINFO_SUCCESS, customerServiceInfo };
}

export function loadingCustomerServiceInfo(customerServiceInfo) {
    return { type: LOADING_CUSTOMERSERVICEINFO };
}

export function loadCustomerServiceInfoFailure(error) {
    return { type: LOAD_CUSTOMERSERVICEINFO_FAILURE, error };
}